import { Component,OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticateApiService } from "@services/rest/authenticate-api.service";
import { TokenService } from '@services/rest/token.service';
import { AuthenticateRequestModel } from "@model/authenticate.model";
import { Router } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-dashboard',
    templateUrl: 'login.component.html',
    standalone: false
})


export class LoginComponent implements OnInit {

    form  : UntypedFormGroup
    submitted = false;
    authenticateRequestModel : AuthenticateRequestModel={};
  constructor( 
      private authenticateApiService: AuthenticateApiService,
      private router: Router,
      private notification: NzNotificationService,
      private tokenService: TokenService,
      private formBuilder: UntypedFormBuilder,
      private spinner: NgxSpinnerService,
  ) 
  {
  }
  
  ngOnInit(): void {
      this.form = this.formBuilder.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required]]
        
    });

  }

  onSubmit(){

    this.submitted = true;

    if (this.form.invalid) {
        return;
    }

    this.spinner.show();   

    this.authenticateRequestModel.username = this.form.get('username').value;
    this.authenticateRequestModel.password = this.form.get('password').value;
    this.authenticateApiService
      .Authenticate( this.authenticateRequestModel)
      .subscribe(response => {
        if(response.success == false)
        {
          this.spinner.hide();  
          this.showNotification(response.errorMessage,response.success);          
        }else{
         this.spinner.hide();   
          
          this.tokenService.setAccessToken(response.accessToken);
          this.tokenService.setUser(JSON.stringify(response.user));
          this.tokenService.setPermissions(response.permissionNames);
          this.tokenService.setBranch(JSON.stringify(response.branch));
          this.tokenService.setRoles(response.roles);
          this.router.navigateByUrl("/");
        }
      });
  }

  get f(): { [key: string]: AbstractControl; } {
    return this.form.controls;
  }

  showNotification(message,status){
    if(status === true){
        this.notification.success(message,""); 
    }
    else{
        this.notification.error(message,"");
    }
  }

}
